import {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import config, { apiUrl, defaultFetchOpts as opts } from '../config';
import { ErrorReporter } from '../utils';

const cardcreatorMap = {
  'rss.webpart': { url: 'https://adenin-artifacts.pages.dev/embed/CardCreator', tenants: [] },
  'linkedin.webpart': { url: 'https://adenin-artifacts.pages.dev/embed/CardCreator', tenants: [] },
  'outlook.webpart': { url: 'https://adenin-artifacts.pages.dev/embed/CardCreator', tenants: [ 8480 ] },
};

function Authenticate() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const checkToken = useCallback(async (token, returnUrl) => {
    opts.headers.Authorization = `Bearer ${token}`;

    let url = `${apiUrl}/session/myprofile?signIn=true`;

    if (searchParams.has('channel')) {
      url += `&channel=${searchParams.get('channel')}`;
    }

    window.$at.auth_searchParams = searchParams;
    const response = await fetch(url, opts);
    const data = await response.json();

    if (!response.ok || !data.Data?.authenticated) {
      ErrorReporter.error(`Token response was not valid when trying to authenticate embed route for ${returnUrl}`);
      window.location.href = `${window.location.origin}/login?returnUrl=${encodeURIComponent(returnUrl)}`;
      return;
    }

    sessionStorage.setItem('pkce_token', JSON.stringify({
      access_token: token,
    }));

    const channel = searchParams.get('channel');
    const linkVersion = searchParams.get('v') || '100';
    const cardCreator = cardcreatorMap[channel];

    // redirect selected cardcreator links to custom config page
    if (channel && cardCreator && returnUrl.includes('cardcreator') && linkVersion > '100') {
      if (cardCreator.tenants.includes(data.Data.tenantIdRaw) || cardCreator.tenants.length === 0) {
        const paramsCopy = new URLSearchParams(searchParams);
        const t = paramsCopy.get('token');
        const tsrc = paramsCopy.get('tokensrc') || 'office-365';

        paramsCopy.set('token', `${tsrc}:${t}`);

        let url = cardCreator.url;

        if (linkVersion === '102') { 
          url = url.replace('CardCreator', 'CardCreator102');
        }

        window.location.href = `${url}?${paramsCopy.toString()}`;
        return;
      }
    }

    const normReturn = returnUrl.toLowerCase();

    if (normReturn.includes('copynotebook') || normReturn.includes('oauth2connector')) {
      window.location.href = returnUrl;
      return;
    }

    navigate(returnUrl);
  }, [navigate, searchParams]);

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (checked) {
      return;
    }

    const returnUrl = searchParams.get('returnUrl');

    if (!returnUrl) {
      navigate(config.defaultPath);
      return;
    }

    if (!returnUrl.startsWith('http')) {
      // returnUrl = `${window.location.origin}${returnUrl}`;
    }

    let token = searchParams.get('token');

    if (!token) {
      window.location.href = `${window.location.origin}/login?returnUrl=${encodeURIComponent(returnUrl)}`;
      return;
    }

    const src = searchParams.get('tokensrc');

    if (src) {
      token = `${src}:${token}`;
    }

    checkToken(token, returnUrl);
    setChecked(true);
  }, [checkToken, checked, navigate, searchParams]);

  return null;
}

export default Authenticate;
